<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Asistencia</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                  v-model="filter_init" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Asistencia" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'">
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Personal", _style: "width:10%;" },
  { key: "date_init", label: "Entrada", _style: "width:10%;" },
  { key: "date_end", label: "Salida", _style: "width:10%;" },
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "assists",
      fields,
      data: [],
      filter_init: null,
      componentKey: 0,
    };
  },
  created() {
    moment.locale("es");
    this.filter_init = moment().format("YYYY-MM-DD");
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_data: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byAssists",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter_init,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            const barbers = response.data.user;
            const data = response.data.data;
            
            // Mapeamos todos los barbers asegurándonos de que aparezcan en la lista
            this.data = barbers.map((barber, index) => {
              // Buscamos si hay un registro en data que coincida con el user_id
              const record = data.find(item => item.user_id == barber.user_id);

              return {
                id: barber.user_id,
                name: `${barber.name} ${barber.last_name}`,
                date_init: record ? this.formatDateTime(record.date_init) : "",
                date_end: record ? (record.date_end === null ? "" : this.formatDateTime(record.date_end)) : "",
                index: index + 1,
                // color: record?.date_init ? "" : "background: #dc3545" ,
              };
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    // Función para formatear la fecha
    formatDateTime: function (dateTime) {
      const date = new Date(dateTime);
      const formattedDate = date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const formattedTime = date.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      return `${formattedDate} ${formattedTime}`;
    }
  },
};
</script>

<style lang="scss" scoped></style>